export const COMPANY_NAME = '山西半径生活信息技术有限公司'
export const COMPANY_SHORT_NAME = '创捷云'


// WEBPACK FOOTER //
// ./src/constants/index.js